import cx from 'classnames';
import type { BlockViewProps } from '@plone/types';

import styles from '@redturtle/qubicaamf-theme/components/Blocks/VideoBanner/styles.module.css';
import type { VideoBannerData } from '@redturtle/qubicaamf-theme/components/Blocks/VideoBanner/schema';
import VideoBanner from './VideoBanner';

type VideoBannerViewProps = Omit<BlockViewProps, 'data'> & {
  data: VideoBannerData;
};

const View = (props: VideoBannerViewProps) => {
  const { className, data } = props;

  return (
    <section className={cx('block-video-banner', className)}>
      <div className={styles.bannerContainer}>
        <VideoBanner data={data} />
      </div>
    </section>
  );
};

export default View;
